<app-toasts></app-toasts>


<div *ngIf="!isLoggedIn" class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-75" style="z-index: 9999;">
  <div class="card p-4 shadow-lg">
    <h3 class="text-center mb-4">Welcome to SEH</h3>
    <p class="text-center mb-4">Please sign in to continue</p>
    <button class="btn btn-primary btn-lg" (click)="login()">
      <i class="bi bi-microsoft me-2"></i>
      Sign in with Microsoft
    </button>
  </div>
</div>

<!-- layout.component.html -->
<div class="container-fluid p-0">
  <app-loading-spinner></app-loading-spinner>

  <!-- Top Navigation Bar -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <!-- Navbar Brand with Logo -->
      <a class="navbar-brand" routerLink="/">
        <img src="logo.png" alt="ICS.AI Logo">
      </a>

      <!-- Navbar Links -->
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link" routerLink="/departments">Departments</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/service-areas">Service Areas</a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="knowledgeBaseDropdown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            Knowledge Base Items
          </a>
          <ul class="dropdown-menu" aria-labelledby="knowledgeBaseDropdown">
            <li *ngFor="let area of serviceAreas" class="dropdown-item">
              <a class="d-flex align-items-center" [routerLink]="['/knowledge-base-items', area.id]">
                <i class="bi bi-book me-2"></i>
                <span>{{ area.name }}</span>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="adminDropDown" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            Admin
          </a>
          <ul class="dropdown-menu" aria-labelledby="adminDropDown">
            <li class="dropdown-item">
              <a class="d-flex align-items-center" routerLink="/audit-logs">
                <i class="bi bi-journal me-2"></i>
                <span>Audit Logs</span>
              </a>
            </li>
            <li class="dropdown-item">
              <a class="d-flex align-items-center" routerLink="/organization">
                <i class="bi bi-gear me-2"></i>
                <span>Organization Config</span>
              </a>
          </ul>
        </li>

        <li class="nav-item">
          <a class="nav-link" role="button" *ngIf="!isLoggedIn" (click)="login()">Login</a>
          <a class="nav-link" role="button" *ngIf="isLoggedIn" (click)="logout()">
            Logout ({{ userName }})
          </a>
        </li>
      </ul>
      
      <!-- Organization Selector -->
      <div *ngIf="isLoggedIn" class="d-flex align-items-center">
        <select id="organization" [(ngModel)]="selectedOrganizationId" class="form-select form-select-sm"
          (change)="onOrganizationChange($event)">
          <option value="" selected>--Select Organization--</option>
          <option *ngFor="let organization of organizations" [value]="organization.id"> {{ organization.displayName }} </option>
        </select>
      </div>
    </div>
  </nav>

  <!-- Main Content -->
  <div class="container mt-4">
    <router-outlet></router-outlet>
  </div>

   <!-- Footer -->
      <footer class="bg-light p-3 border-top text-center">
        <p class="mb-0">&copy; 2025 ICS.AI. All rights reserved.</p>
      </footer>
</div>

<!-- Offcanvas Side Panel -->
<div class="offcanvas offcanvas-end" tabindex="-1" id="workflowOffcanvas" aria-labelledby="workflowOffcanvasLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="workflowOffcanvasLabel">Workflow Progress</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div class="list-group">
      <div class="list-group-item d-flex align-items-center">
        <i class="me-2" [ngClass]="{
              'bi bi-check-circle-fill text-success': isDepartmentEntryComplete,
              'bi bi-circle text-muted': !isDepartmentEntryComplete
            }"></i>
        Departments Information Completed
      </div>
      <hr class="my-3" *ngIf="workflowSteps.length > 0">
      <h6 class="text-muted px-3 py-2" *ngIf="workflowSteps.length > 0">Department Checklist</h6>
      <div class="list-group-item d-flex align-items-center" *ngFor="let step of workflowSteps">
        <i class="me-2" [ngClass]="{
              'bi bi-check-circle-fill text-success': step.completed,
              'bi bi-circle text-muted': !step.completed
            }"></i>
        {{ step.title }}
      </div>
      <div class="list-group-item" *ngIf="workflowSteps.length === 0">No workflow steps available.</div>
    </div>
  </div>
</div>


@if(false) {
  <!-- Offcanvas Toggle Button -->
  <button class="btn btn-outline-light me-3 disabled" type="button" data-bs-toggle="offcanvas"
    data-bs-target="#workflowOffcanvas" aria-controls="workflowOffcanvas">
    Show Workflow Progress
  </button>
}
